// Compute a cable's route length (from geometry, fallback to length_m) and its
// optical length = route length + sum of all cable slacks (reserves) tied to it.
function haversine(a, b) {
  const R = 6371000, toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b[0] - a[0]), dLng = toRad(b[1] - a[1]);
  const s = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
}

export function cableRouteLength(cable) {
  const g = cable.geometry || [];
  if (g.length > 1) {
    let d = 0;
    for (let i = 1; i < g.length; i++) d += haversine(g[i - 1], g[i]);
    return d;
  }
  return Number(cable.length_m || cable.length || 0);
}

const r1 = (n) => Math.round(n * 10) / 10;

export function cableOptical(cable, slacks) {
  const route = cableRouteLength(cable);
  const slack = (slacks || [])
    .filter((s) => s.cable === cable.id)
    .reduce((a, s) => a + (Number(s.length_m) || 0), 0);
  return { route: r1(route), slack: r1(slack), optical: r1(route + slack) };
}
